<ion-content class="modal-outher-container">
  <ion-grid class="modal-inner-container modal-inner-container--small">
    <ion-row class="content-padding-vertical">
      <ion-col>
        <app-modal-header
          header="{{ 'DETAILS' | translate }} "
          [alwaysDesktopButton]="true"
          (close)="onCloseModal()"
        ></app-modal-header>
        <ion-grid fixed>
          <ion-row>
            <ion-col size="12">
              <table class="user-assignment-view-details__data-table">
                <tr>
                  <td>
                    {{ "SPACE.SPACE_BUILDING" | translate }}
                  </td>
                  <td>
                    {{ spaceDetails?.floor?.building?.name }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ "SPACE.SPACE_FLOOR" | translate }}
                  </td>
                  <td>
                    {{ spaceDetails?.floor?.name }}
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ "SPACE.SPACE_NUMBER" | translate }}
                  </td>
                  <td>
                    {{ spaceDetails?.name }}
                  </td>
                </tr>
                <tr *ngIf="spaceDetails.equipments?.length > 0">
                  <td>
                    {{ "SPACE.ROOM.EQUIPMENT" | translate }}
                  </td>
                  <td>
                    <ng-container
                      *ngFor="
                        let equipment of spaceDetails.equipments;
                        let i = index
                      "
                    >
                      {{ equipment.name
                      }}<ng-container
                        *ngIf="i + 1 < spaceDetails.equipments.length"
                        >,
                      </ng-container>
                    </ng-container>
                  </td>
                </tr>
              </table>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="spaceDetails.subType">
            <ion-col size="12">
              <div class="user-assignment-view-details__spacetype">
                <ion-icon
                  [src]="spaceService.searchSubtypeIcon(spaceDetails.subType)"
                >
                </ion-icon>
                <ion-label>
                  {{ subTypeName }}
                </ion-label>
              </div>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="spaceDetails.image">
            <ion-col size="12">
              <div class="user-assignment-view-details__image-container">
                <img
                  (click)="onImagePreview($event, spaceDetails.image.filePath)"
                  [src]="spaceDetails.image.filePath"
                />
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
